import { http } from '../../http';
import { EchoFilterRequest } from '../filter/types';
import {
    InteractionAudioMetaData,
    RequestGetInteractions,
    RequestInteractionTable,
    RequestUpdateTableLayout,
    ResponseGetInteractions,
    ResponseInteractions,
} from './types';

export const getInteractionTable = async (
    req: RequestInteractionTable
): Promise<ResponseInteractions> => {
    return http
        .post('interaction/table', req)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching interactions', error);
            throw error;
        });
};

export function getInteractionCount(f: EchoFilterRequest): Promise<number> {
    return http
        .post<{count: number}>('interaction/count', f)
        .then(res => res.data.count)
        .catch(err => {
            console.error('Error fetching interactions', err);
            throw err;
        });
};

export const getInteractions = async (
    req: RequestGetInteractions
): Promise<ResponseGetInteractions> => {
    return http
        .post(`interaction/interactions`, req.ids)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error fetching interaction', error);
            throw error;
        });
};

export const updateInteractionTableLayout = async (req: RequestUpdateTableLayout) => {
    return http
        .patch<RequestUpdateTableLayout, void>('interaction/table-layout', req)
        .catch((error) => {
            console.error('Error updating table layout', error);
            throw error;
        });
};

export const getInteractionAudioMetaData = async (
    interactionPartId: string
): Promise<InteractionAudioMetaData> => {
    return http
        .get<InteractionAudioMetaData>(`interaction/${interactionPartId}/audio-metadata`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error fetching interaction audio metadata', error);
            throw error;
        });
};
